<div [formGroup]="group" [hidden]="config.hidden" class="form-group">
  @if (config.label) {
    <label [for]="config.fullyQualifiedName">{{ config.label | translate }}</label>
  }
  <input class="form-control" [class.missing]="isMissing" [class.complete]="isComplete" [class.invalid]="isInvalid"
    type="text" [id]="config.fullyQualifiedName" [name]="config.fullyQualifiedName"
    [placeholder]="config.placeholder | translate" [formControlName]="config.formControlName">
</div>
